import { render, staticRenderFns } from "./DGOCol.vue?vue&type=template&id=0cd4416e&"
import script from "./DGOCol.js?vue&type=script&lang=js&"
export * from "./DGOCol.js?vue&type=script&lang=js&"
import style0 from "./DGOCol.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports